export default __webpack_public_path__ + "static/media/customers.54200476.svg";